import React, { useEffect } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect,
} from "react-router-dom";
import LoginPage from "./views/UserProfile/LoginPage";
import { Provider } from "react-redux";
import store from "./store";
import AuthProvider from "./utils/authProvider";
import oauth, { loadUserFromStorage } from "./_services/oauth";
import PrivateRoute from "./utils/protectedRoute";

// core components
import AuthLayout from "layouts/Auth.js";


import Datacenter from "layouts/Datacenter";
import Repair from "layouts/Repair.js";
import Leave from "layouts/Leave.js";
import Finance from "layouts/Finance.js";
import Meeting from "layouts/Meeting.js";
import Vehicle from "layouts/Vehicle.js";
import Asset from "layouts/Asset.js";
import HA from "layouts/HA.js";
import ServiceSystem from "layouts/ServiceSystem.js";
import Home from "layouts/Home.js";
import HR from "layouts/HR.js";
import Login from "layouts/Login.js";
import Signature from "layouts/Signature";
import SubSignature from "layouts/SubSignature";
import VaccineLayout from "layouts/VaccineLayout";
import Consent from "layouts/Consent";
import Auth from "layouts/Auth";
import Cyber from "layouts/Cyber.js";
import Budget from "layouts/Budget";
import KPI from "layouts/KPI";
import Trainee from "layouts/Trainee";
import FileBorrow from "views/Asset/FileBorrow";

import R506 from "layouts/R506";

import ReportAccess from "views/Report/ReportAccess";
import ICD10 from "views/ICD10/ICD10.js";
import CCNote from "views/ICD10/CCNote.js";
import ProviderID from "views/UserProfile/ProviderID.js";
import ResetPwd from "views/UserProfile/ResetPwd.js";

import PdfFile from "views/Report/PdfFile.js";
import ESignPdf from "views/Consent/ESignPdf";
import DataAnalysis from "layouts/DataAnalysis";
import Dormitory from "layouts/Dormitory";


function App() {
  useEffect(() => {
    // fetch current user
    //loadUserFromStorage(store);
  }, []);

  return (
    <Provider store={store}>
      <AuthProvider userManager={oauth} store={store}>
        <Router>
          <Switch>
          <Route path="/file/asset/borrow/:fileID" component={FileBorrow} />
          <Route path="/datacenter/access/:month" render={props => <ReportAccess {...props} />} />
          <Route path="/home" component={Home} />
          <Route path="/datacenter" component={Datacenter} />
          <Route path="/signature" component={Signature} />
          <Route path="/subsignature" component={SubSignature} />
          <Route path="/vaccine" component={VaccineLayout} />
          <Route path="/vehicle" component={Vehicle} />
          


          <Route path="/repair" component={Repair} />
          <Route path="/meeting" component={Meeting} />
          <Route path="/finance" component={Finance} />
          <Route path="/refund" component={Finance} />
          <Route path="/vehicle" component={Vehicle} />
          <Route path="/consent" component={Consent} />

          <Route path="/asset" component={Asset} />
          <Route path="/ha" component={HA} />
          <Route path="/leave" component={Leave} />
          <Route path="/servicesystem" component={ServiceSystem} />
          <Route path="/data-analysis" component={DataAnalysis} />
          <Route path="/hr" component={HR} />
          <Route path="/cyber" component={Cyber} />

          <Route path="/budget" component={Budget} />
          <Route path="/kpi" component={KPI} />
          <Route path="/trainee" component={Trainee} />
          <Route path="/dormitory" component={Dormitory} />
          <Route path="/r506" component={R506} />


          <Route path="/login" component={Login} />
          <Route path="/auth" component={Auth} />
          <Route path="/pdf/leave/:LeaveRequestID" render={(props) => <PdfFile {...props} />} />
          <Route path="/pdf/report/:ReportId" render={(props) => <ESignPdf {...props} />} />
          <Route path="/icd10/:serviceUnitKey/:startDate/:endDate" render={props => <ICD10 {...props} />} />
          <Route path="/ccnote/:serviceUnitKey/:startDate/:endDate" render={props => <CCNote {...props} />} />
          <Route path="/moph/redirect/" render={props => <ProviderID {...props} />} /> 

          <Redirect from="/" to="/home" />           
          {/*
            <PrivateRoute path="/admin/user" component={Admin} />
            <PrivateRoute path="/admin" component={Admin} />
            <PrivateRoute path="/rtl" component={RTL} />

            <Route path="/login-page" component={LoginPage} />
            <Route path="/auth" component={AuthLayout} />

                      <Redirect from="/" to="/admin/dashboard" />

          */}
          </Switch>

        </Router>
      </AuthProvider>
    </Provider>
  );
}

export default App;
